<!--  -->
<template>
    <div class='content'>
        <img class="login_content_img" src="@/assets/img/10.png" alt="">
        <div class="login-content">
            <div class="login-input">
                <!-- <img class="wecome" src="@/assets/img/4.png" alt=""> -->
                <div class="title">三贤山水上餐厅</div>
                <div class="input">
                    <el-input class="mobile" v-model="mobile" :placeholder="language['请输入手机号/账号'][LT]"></el-input>
                    <el-input class="password" :placeholder="language['请输入密码'][LT]" v-model="password"
                        show-password></el-input>
                </div>
                <el-button class="login_btn" @click="getLogin" type="warning">{{ language['登录'][LT] }}</el-button>
            </div>
            <img class="login_img" src="@/assets/img/1.png" alt="">
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { validate } from "@/assets/js/validate";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            mobile: '',
            password: ''
            // mobile: '15515731580',
            // password: 'a111111'
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getLogin() {
            if (this.mobile == '') {
                this.$message.error(this.language['账号不能为空'][this.LT]);
                return false;
            }
            // if (!validate(this.mobile, 'phone')) {
            //     this.$message.error(this.language['账号格式不正确'][this.LT]);
            //     return false;
            // }
            if (this.password == '') {
                this.$message.error(this.language['密码不能为空'][this.LT]);
                return false;
            }
            if (!validate(this.password, 'password')) {
                this.$message.error(this.language['密码格式不正确'][this.LT]);
                return false;
            }
            this.$post('6459ea02ba473', { mobile: this.mobile, password: this.password }).then(res => {
                if (res.code == 1) {
                    console.log('登录成功', res);
                    this.$message({
                        message: this.language['登录成功'][this.LT],
                        type: 'success'
                    });
                    localStorage.setItem('userInfo', JSON.stringify(res.data.userinfo));
                    localStorage.setItem('TOKEN', JSON.stringify(res.data.userinfo.user_token));
                    this.$EventBus.$emit("login");
                    setTimeout(() => {
                        this.$router.push({ path: "/" });
                    }, 1000)
                } else {
                    this.$message.error(res.msg);
                }
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style scoped>
 .content {
     margin: 0;
     padding-top: 5%;
     box-sizing: border-box;
 }
 .title{
  font-size:38px;
  font-weight: 600;
 }
 .login_content_img {
     position: absolute;
     top: 0;
     left: 0;
     width: 100%;
     height: 100vh;
 }

 .login-content {
     margin: 0 auto;
     padding: 80px;
     display: flex;
     justify-content: space-between;
     align-items: center;
     background: #fff;
     box-sizing: border-box;
     position: relative;
     z-index: 1024;
     width: 80%;
 }

 .login_img {
     /* width: 740px; */
     width: 50%;
     height: 460px;
 }

 .wecome {
     width: 323px;
     height: 96px;
 }

 .input {
     margin: 88px 0 72px;
 }

 .mobile {
     margin-bottom: 32px;
     width: 380px;
 }

 .password {
     width: 380px;
 }

 .login_btn {
     width: 240px;
     height: 48px;
 }
</style>



// WEBPACK FOOTER //
// src/view/login/login.vue